import Component from '../Component';
import * as eventNames from '../../customEventStrings';
import * as uiStrings from '../../uiStrings';
import Block from './Block';
//import RemoveFilters from './RemoveFilters';
//import Row from './Row';
import childrenAdminData from './childrenData/admin';
import childrenNareciData from './childrenData/nareci';
import childrenHistoricData from './childrenData/historic';
import childrenReliefData from './childrenData/relief';

class Filters extends Component {
    constructor(props) {
        super(props);

        this.dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);

        this.adminBlock = new Block({
            headingText: uiStrings.ADMINISTRATIVE_DIVISION_HEADING,
            controlClassName: 'js-layers-overlay',
        });

        this.nareciBlock = new Block({
            blockClassName: 'js-layers-filterable',
            headingText: uiStrings.DIALECTAL_DIVISION_HEADING,
            controlClassName: 'js-layers-overlay',
        });

        this.historicBlock = new Block({
            headingText: uiStrings.HISTORICAL_DIVISION_HEADING,
            controlClassName: 'js-layers-overlay',
        });

        this.reliefBlock = new Block({
            headingText: uiStrings.BACKGROUND_HEADING,
            controlClassName: '',
        });

        //this.removeFilters = new RemoveFilters();
    }

    componentDidMount() {
        this.adminBlock.setRefs(this.refs);
        this.nareciBlock.setRefs(this.refs);
        this.historicBlock.setRefs(this.refs);
        this.reliefBlock.setRefs(this.refs);
        //this.removeFilters.setRefs(this.refs);

        this.adminBlock.componentDidMount();
        this.nareciBlock.componentDidMount();
        this.historicBlock.componentDidMount();
        this.reliefBlock.componentDidMount();
        //this.removeFilters.componentDidMount();
    }

    toggleActive() {
        this.refs['content-filters'].classList.toggle('active');
    }

    render() {
        return (`
            <div ref="content-filters" class="layerPanel__content--filters scroll">
                ${this.adminBlock.setChildren(childrenAdminData).render()}
                ${this.nareciBlock.setChildren(childrenNareciData).render()}
                ${this.historicBlock.setChildren(childrenHistoricData).render()}
                <hr class="layerPanel__block-separator">
                ${this.reliefBlock.setChildren(childrenReliefData).render()}
            </div>`
        );
/* TODO: remove
        return (`
            <div ref="content-filters" class="layerPanel__content--filters scroll">
                ${this.adminBlock.setChildren(childrenAdminData).render()}
                ${this.nareciBlock.setChildren(childrenNareciData).render()}
                ${this.historicBlock.setChildren(childrenHistoricData).render()}
                <hr class="layerPanel__block-separator">
                ${this.reliefBlock.setChildren(childrenReliefData).render()}
                <hr class="layerPanel__block-separator">
                ${this.removeFilters.render()}
            </div>`
        );
*/
    }
}

export default Filters;
